import { render } from "./product-options.vue?vue&type=template&id=3ca3d98e"
import script from "./product-options.vue?vue&type=script&lang=js"
export * from "./product-options.vue?vue&type=script&lang=js"

import "./product-options.vue?vue&type=style&index=0&id=3ca3d98e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__